import { useUi, type AskRequest, type ConfirmRequest } from '../store/ui'

/** Promise-based replacements for window.confirm / window.prompt, rendered by <DialogHost /> in the app shell. */
export const confirmDialog = (r: Omit<ConfirmRequest, 'resolve'>) =>
  new Promise<boolean>((resolve) => useUi.getState().setConfirm({ ...r, resolve }))

export const askDialog = (r: Omit<AskRequest, 'resolve'>) =>
  new Promise<string | null>((resolve) => useUi.getState().setAsk({ ...r, resolve }))
